export enum CaseType {
    CollectionNotice = 0,
    CollectionCase,
    CMSCollectionCase,
    CMSDebtAdmin
}